<div class="col" *ngIf="data!=null">
    <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
        <ng-container *ngFor="let item of data.destinationsData; let i = index">
            <input type="radio" name="pcss3t"
                [(ngModel)]="tab" [value]="i" checked id="tab{{i}}">
            <label for="tab{{i}}">
                {{item.destinationName}}
            </label>
        </ng-container>

    </div>
    <div class="table-responsive" *ngFor="let item of data.destinationsData; let i = index">
        <table class="table  table-sm position-relative" [hidden]="tab!==i">
            <thead>
              <tr>
                <th>Codigo</th>
                <th>cliente</th>
                <th class="text-end">Saldo Inicial</th>
                <th class="text-end">Ventas</th>
                <th class="text-end">Abonos</th>
                <th class="text-end">Saldo Final</th>
                <th class="text-end">Dias de Credito</th>
                <th class="text-end">Dias sin Venta</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of item.items">
                <td>{{row.codigo}}</td>
                <td>{{row.cliente}}</td>
                <td class="text-end">{{row.saldoInicial | currency: 'Q'}}</td>
                <td class="text-end">{{row.ventas | currency: 'Q'}}</td>
                <td class="text-end">{{row.abonos | currency: 'Q'}}</td>
                <td class="text-end">{{row.saldoFinal | currency: 'Q'}}</td>
                <td class="text-end">{{row.diasDeCredito}}</td>
                <td class="text-end">{{row.diasSinVenta}}</td>
              </tr>
            </tbody>
        </table>
    </div>
</div>